import { css } from '@microsoft/fast-element';
/**
 * Custom Drag n Drop CSS for Grid Pro.
 * @remarks helps with color and background issues when dragging a column.
 * @public
 */
export const agHeadCSS = css `
  .ag-dnd-ghost {
    background: var(--ag-header-background-color, var(--ag-background-color, #1f2126));
    border: solid 1px;
    border-color: var(--ag-header-foreground-color, var(--ag-foreground-color, #879ba6));
    border-radius: calc(var(--control-corner-radius) * 1px);
    color: var(--ag-header-foreground-color, var(--ag-foreground-color, #879ba6));
    font-family: var(--ag-font-family, var(--body-font));
    font-size: 12px;
    height: 32px;
    line-height: 28px;
    margin: 0;
    padding: 0 12px;
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
